import React from "react";
import { Button, ButtonProps } from "@campgladiator/cgui-core.atoms.button";
import { Link, LinkProps } from "@campgladiator/cgui-core.atoms.link";
import styles from "./Buttons.module.scss";

export type ButtonsProps = {
  buttons:
    | ButtonProps[]
    | {
        children: string;
        onClick: (
          event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
        ) => void;
      }[];
};

const Buttons = ({ buttons }: ButtonsProps) => (
  <div className={styles.buttonContainer}>
    {buttons.map((button, index) => {
      if (button && button.buttonType === "button") {
        return <Button key={index} {...button} />;
      } else {
        return (
          <Link
            key={index}
            className={styles.link}
            hideArrow
            size="small"
            onClick={button.onClick}
          >
            {button.children}
          </Link>
        );
      }
    })}
  </div>
);

export default Buttons;
